import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Repeat } from 'lucide-react';

/**
 * Widget compacto para comparar el tiempo entre dos etapas (leads.status u
 * opportunities.stage). Reemplaza el ChartCard grande original -- feedback
 * owner jul2026: "un dato simple no necesita tanto espacio".
 *
 * Props:
 *  - stages: [{id, name}] catalogo de etapas para los selects
 *  - stageA/stageB: ids seleccionados
 *  - onChangeA/onChangeB: setters
 *  - value: string ya formateado (ej. "37s", "2.1h")
 *  - n: numero de casos detras del promedio
 *  - loading, testid
 */
export default function StageCompareWidget({ stages, stageA, stageB, onChangeA, onChangeB, value, n, loading, testid }) {
  const nameOf = (id) => stages.find(s => s.id === id)?.name || id;
  return (
    <Card className="bg-card/50 backdrop-blur-md border-white/10 shrink-0" data-testid={testid}>
      <CardContent className="p-3 flex items-center gap-3 flex-wrap">
        <div className="w-6 h-6 rounded-md bg-violet-500/10 flex items-center justify-center shrink-0">
          <Repeat className="w-3.5 h-3.5 text-violet-400" />
        </div>
        <div className="flex items-center gap-1.5 shrink-0">
          <Select value={stageA} onValueChange={onChangeA}>
            <SelectTrigger className="h-6 w-28 bg-black/20 border-white/10 text-[9px]" data-testid={`${testid}-a`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {stages.map(s => <SelectItem key={s.id} value={s.id} className="text-xs">{s.name}</SelectItem>)}
            </SelectContent>
          </Select>
          <span className="text-[9px] text-muted-foreground">→</span>
          <Select value={stageB} onValueChange={onChangeB}>
            <SelectTrigger className="h-6 w-28 bg-black/20 border-white/10 text-[9px]" data-testid={`${testid}-b`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {stages.map(s => <SelectItem key={s.id} value={s.id} className="text-xs">{s.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="ml-auto text-right">
          {loading ? (
            <div className="h-5 w-14 bg-white/5 rounded animate-pulse ml-auto" />
          ) : (
            <p className="text-lg font-bold text-violet-400 font-heading leading-none">{value}</p>
          )}
          <p className="text-[9px] text-muted-foreground mt-0.5">{nameOf(stageA)} → {nameOf(stageB)} ({n ?? 0})</p>
        </div>
      </CardContent>
    </Card>
  );
}
